import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 18 19",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M9 0.571427C4.0279 0.571427 0 4.59933 0 9.57143C0 14.5234 4.01786 18.5714 9 18.5714C13.9922 18.5714 18 14.5134 18 9.57143C18 4.59933 13.9721 0.571427 9 0.571427ZM15.2176 14.1417C14.856 12.3437 13.9821 10.8571 12.144 10.8571C11.3304 11.6507 10.2254 12.1429 9 12.1429C7.77455 12.1429 6.66964 11.6507 5.85603 10.8571C4.01786 10.8571 3.14397 12.3437 2.78237 14.1417C1.84821 12.856 1.28571 11.279 1.28571 9.57143C1.28571 5.32254 4.75112 1.85714 9 1.85714C13.2489 1.85714 16.7143 5.32254 16.7143 9.57143C16.7143 11.279 16.1518 12.856 15.2176 14.1417ZM12.8571 7.64286C12.8571 9.77232 11.1295 11.5 9 11.5C6.87054 11.5 5.14286 9.77232 5.14286 7.64286C5.14286 5.51339 6.87054 3.78571 9 3.78571C11.1295 3.78571 12.8571 5.51339 12.8571 7.64286Z" }));
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
